import { Injectable } from '@angular/core';
import { ApiService } from '../../../shared/services/api.service';
import { IMetadataTags, IPostMetadataTags } from '../models/Metadata-tags';

@Injectable({
  providedIn: 'root',
})
export class MetadataTagsService {
  constructor(private apiService: ApiService) {}
  readonly metadataTagsRoot = 'api/metadata-tags';

  public getMetadataTags() {
    const fullAPIUrl = this.apiService.buildFullURL(this.metadataTagsRoot, ``);
    return this.apiService.get<IMetadataTags>(fullAPIUrl, { withCredentials: true });
  }

  public postMetadataTags(metadataTags: IPostMetadataTags) {
    const fullAPIUrl = this.apiService.buildFullURL(this.metadataTagsRoot, ``);
    return this.apiService.post<IMetadataTags>(fullAPIUrl, metadataTags, { withCredentials: true });
  }

  public deleteMetadataTags(metadataTagId: number) {
    const fullAPIUrl = this.apiService.buildFullURL(this.metadataTagsRoot, `${metadataTagId}/`);
    return this.apiService.delete(fullAPIUrl, { withCredentials: true });
  }
}
